import React from 'react';
import cx from 'classnames';
import styles from './EngageSidebar.module.scss';
import { Icon } from '../Icon';
import { CustomButton } from '../Button/Button';

const SidebarExternalLink = ({ mini, text, link, newTab = false, allowAnimation }) => {
  const handleClick = () => {
    if (newTab) {
      window.open(link, '_blank');
    } else {
      window.location.href = link;
    }
  };

  return (
    <CustomButton
      className={cx(styles.sidebarSection, styles.sidebarExternalLink, { [styles.mini]: mini }, { [styles.animate]: allowAnimation })}
      variant="link"
      onClick={handleClick}
      ariaLabel={mini && 'Open support page'}
    >
      <Icon className={styles.sidebarIcon} src="external_vormats" />
      {mini ? null : <span className={styles.name}>{text}</span>}
    </CustomButton>
  );
};

export default SidebarExternalLink;
